<template>
   <!--卡片-->
    <div class="kpDiv">
      <img src="../../static/image/wm1.png" alt="" />
      <img src="../../static/image/wm2.png" alt="" />
      <img src="../../static/image/wm3.png" alt="" />
      <img src="../../static/image/wm4.png" alt="" />
      <div  class="footer">
        <div class="ghDiv">
          <img class="ghImg" src="../../static/image/gh.png" alt="" :style="{width: isMobile ? '15px' : '25px'}" />
          <a href="https://beian.miit.gov.cn/#/Integrated/index" :style="{fontSize: isMobile ? '8px' : '14px'}">京ICP备2026000484号-1</a>
        </div>
        <img src="../../static/image/footer.png" alt="" />
      </div>
    </div>
</template>

<script>
export default {
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
};
</script>


<style lang="scss" scoped>
.kpDiv {
  display: flex;
  flex-direction: column;
  img {
    width: 100%;    
    max-width: 100%;
    height: auto;  
  }
}
</style>